import { render, staticRenderFns } from "./Samyoga2025Estadistica.vue?vue&type=template&id=c2be5570&"
import script from "./Samyoga2025Estadistica.vue?vue&type=script&lang=js&"
export * from "./Samyoga2025Estadistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports